/* eslint-disable max-len */
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { Button } from 'react-toolbox/lib/button';

import { DropdownDiv, ContainerDiv } from './styledComponents';
import ChecklistResponseNote from './checklistResponseNote';
import S from '../styles.scss';

const ChecklistYesNoQuestion = ({
  phaseSpecific, canShow, text, yesDisabled, noDisabled, handleAnswered, answeredArgs, showNote, noteKey,
}) => <Fragment>
  {canShow && <ContainerDiv>
    <DropdownDiv condition={canShow}>
      <div className={S.checklistContainer}>
        <p>{text}</p>
        <br />
        <Button
          label="YES"
          flat inverse ripple
          disabled={yesDisabled}
          className={S.standardButton}
          onClick={() => {
            if (phaseSpecific) handleAnswered(answeredArgs[0], answeredArgs[1], true);
            else handleAnswered(true);
          }}
        />
        <Button
          label="NO"
          flat inverse ripple
          disabled={noDisabled}
          className={S.standardButton}
          onClick={() => {
            if (phaseSpecific) handleAnswered(answeredArgs[0], answeredArgs[1], false);
            else handleAnswered(false);
          }}
        />
      </div>
      <ChecklistResponseNote canShow={showNote} noteKey={noteKey} />
    </DropdownDiv>
  </ContainerDiv>}
</Fragment>;

ChecklistYesNoQuestion.defaultProps = {
  phaseSpecific: false,
  answeredArgs: [],
  showNote: false,
  noteKey: '',
};

ChecklistYesNoQuestion.propTypes = {
  phaseSpecific: PropTypes.bool,
  canShow: PropTypes.bool,
  text: PropTypes.string,
  yesDisabled: PropTypes.bool,
  noDisabled: PropTypes.bool,
  handleAnswered: PropTypes.func,
  answeredArgs: PropTypes.array,
  showNote: PropTypes.bool,
  noteKey: PropTypes.string,
};

export default ChecklistYesNoQuestion;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseSchedulingChecklist/components/checklistYesNoQuestion.jsx